"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FuelPump = function FuelPump() {
  return _react2.default.createElement(
    "g",
    { id: "fuelPump" },
    _react2.default.createElement("path", {
      d: "M375.687 117.22l.238-.277-88.62-103.087L262.05 43.23l50.266 58.47c-22.394 9.977-38.355 34.918-38.355 64.57 0 38.24 26.687 69.278 59.56 69.278 8.578 0 16.44-2.217 23.825-5.82v199.8c0 15.242-10.72 27.712-23.822 27.712-13.1 0-23.822-12.47-23.822-27.71V304.826c0-30.483-21.44-55.423-47.644-55.423h-23.82V55.423C238.23 24.94 216.786 0 190.583 0H47.645C21.44 0 0 24.94 0 55.423v443.384h238.23V290.97h35.733v138.56c0 38.24 26.682 69.277 59.557 69.277 32.876 0 59.557-31.037 59.557-69.278V166.27c0-19.122-6.67-36.58-17.39-49.05zM47.647 55.423h142.936V193.98H47.646V55.424zM333.52 193.98c-13.102 0-23.823-12.47-23.823-27.71 0-15.242 10.72-27.712 23.823-27.712s23.823 12.47 23.823 27.71c0 15.242-10.72 27.713-23.823 27.713z",
      id: "Shape"
    })
  );
};

exports.default = FuelPump;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/FuelPump.js
// module id = 2959
// module chunks = 4